<template>
  <div class="home">
    <Dashboard />
  </div>
</template>
<script>
/**
 * TODO
 */
import Dashboard from "./Dashboard.vue";

export default {
  name: "Home",
  data() {
    return {};
  },
  props: {},
  created() {},
  components: {
    Dashboard
  },
  computed: {},
  methods: {},
  filters: {}
};
</script>
